/*
  Billing: what stops working on a cheaper plan. Merged FIRST into
  TRANSLATION_MAPS in ./index.js, so existing translations of common words
  (Users, Domains…) still win. Keys are the English source.
*/

const ru = {
  "If you switch to {plan}:": "При переходе на {plan}:",
  "{feature}: {n} in use, not included in this plan.": "{feature}: используется — {n}, в этом тарифе нет.",
  "{feature}: {n} now, {limit} on this plan.": "{feature}: сейчас {n}, в этом тарифе — {limit}.",
  "Automation rules": "Правила автоматизации",
  "Custom metrics": "Свои метрики",
  "Conversion types": "Типы конверсий",
  "API keys": "API-ключи",
  "Webhooks": "Вебхуки",
  "Cost sync": "Синхронизация расходов",
  "Domain pools": "Пулы доменов",
  "Lead forms": "Формы с заявками",
  "Users": "Пользователи",
  "Domains": "Домены",
  "Scheduled reports": "Отчёты по расписанию",
  "Public report links": "Публичные ссылки на отчёты",
};

const es = {
  "If you switch to {plan}:": "Si cambias a {plan}:",
  "{feature}: {n} in use, not included in this plan.": "{feature}: {n} en uso, no incluido en este plan.",
  "{feature}: {n} now, {limit} on this plan.": "{feature}: {n} ahora, {limit} en este plan.",
  "Automation rules": "Reglas de automatización",
  "Custom metrics": "Métricas personalizadas",
  "Conversion types": "Tipos de conversión",
  "API keys": "Claves API",
  "Webhooks": "Webhooks",
  "Cost sync": "Sincronización de costes",
  "Domain pools": "Grupos de dominios",
  "Lead forms": "Formularios de leads",
  "Users": "Usuarios",
  "Domains": "Dominios",
  "Scheduled reports": "Informes programados",
  "Public report links": "Enlaces públicos a informes",
};

const pt = {
  "If you switch to {plan}:": "Se você mudar para {plan}:",
  "{feature}: {n} in use, not included in this plan.": "{feature}: {n} em uso, não incluído neste plano.",
  "{feature}: {n} now, {limit} on this plan.": "{feature}: {n} agora, {limit} neste plano.",
  "Automation rules": "Regras de automação",
  "Custom metrics": "Métricas personalizadas",
  "Conversion types": "Tipos de conversão",
  "API keys": "Chaves de API",
  "Webhooks": "Webhooks",
  "Cost sync": "Sincronização de custos",
  "Domain pools": "Pools de domínios",
  "Lead forms": "Formulários de leads",
  "Users": "Usuários",
  "Domains": "Domínios",
  "Scheduled reports": "Relatórios agendados",
  "Public report links": "Links públicos de relatórios",
};

const de = {
  "If you switch to {plan}:": "Beim Wechsel zu {plan}:",
  "{feature}: {n} in use, not included in this plan.": "{feature}: {n} in Verwendung, in diesem Plan nicht enthalten.",
  "{feature}: {n} now, {limit} on this plan.": "{feature}: jetzt {n}, in diesem Plan {limit}.",
  "Automation rules": "Automatisierungsregeln",
  "Custom metrics": "Eigene Metriken",
  "Conversion types": "Conversion-Typen",
  "API keys": "API-Schlüssel",
  "Webhooks": "Webhooks",
  "Cost sync": "Kostensynchronisierung",
  "Domain pools": "Domain-Pools",
  "Lead forms": "Lead-Formulare",
  "Users": "Benutzer",
  "Domains": "Domains",
  "Scheduled reports": "Geplante Berichte",
  "Public report links": "Öffentliche Berichtslinks",
};

const fr = {
  "If you switch to {plan}:": "Si vous passez à {plan} :",
  "{feature}: {n} in use, not included in this plan.": "{feature} : {n} utilisés, non inclus dans ce plan.",
  "{feature}: {n} now, {limit} on this plan.": "{feature} : {n} actuellement, {limit} dans ce plan.",
  "Automation rules": "Règles d’automatisation",
  "Custom metrics": "Métriques personnalisées",
  "Conversion types": "Types de conversion",
  "API keys": "Clés API",
  "Webhooks": "Webhooks",
  "Cost sync": "Synchronisation des coûts",
  "Domain pools": "Groupes de domaines",
  "Lead forms": "Formulaires de leads",
  "Users": "Utilisateurs",
  "Domains": "Domaines",
  "Scheduled reports": "Rapports planifiés",
  "Public report links": "Liens publics vers les rapports",
};

const it = {
  "If you switch to {plan}:": "Se passi a {plan}:",
  "{feature}: {n} in use, not included in this plan.": "{feature}: {n} in uso, non incluso in questo piano.",
  "{feature}: {n} now, {limit} on this plan.": "{feature}: {n} ora, {limit} in questo piano.",
  "Automation rules": "Regole di automazione",
  "Custom metrics": "Metriche personalizzate",
  "Conversion types": "Tipi di conversione",
  "API keys": "Chiavi API",
  "Webhooks": "Webhook",
  "Cost sync": "Sincronizzazione dei costi",
  "Domain pools": "Pool di domini",
  "Lead forms": "Moduli lead",
  "Users": "Utenti",
  "Domains": "Domini",
  "Scheduled reports": "Report programmati",
  "Public report links": "Link pubblici ai report",
};

const pl = {
  "If you switch to {plan}:": "Po przejściu na {plan}:",
  "{feature}: {n} in use, not included in this plan.": "{feature}: w użyciu {n}, brak w tym planie.",
  "{feature}: {n} now, {limit} on this plan.": "{feature}: teraz {n}, w tym planie {limit}.",
  "Automation rules": "Reguły automatyzacji",
  "Custom metrics": "Własne metryki",
  "Conversion types": "Typy konwersji",
  "API keys": "Klucze API",
  "Webhooks": "Webhooki",
  "Cost sync": "Synchronizacja kosztów",
  "Domain pools": "Pule domen",
  "Lead forms": "Formularze leadów",
  "Users": "Użytkownicy",
  "Domains": "Domeny",
  "Scheduled reports": "Raporty zaplanowane",
  "Public report links": "Publiczne linki do raportów",
};

const tr = {
  "If you switch to {plan}:": "{plan} planına geçerseniz:",
  "{feature}: {n} in use, not included in this plan.": "{feature}: {n} kullanımda, bu planda yok.",
  "{feature}: {n} now, {limit} on this plan.": "{feature}: şu an {n}, bu planda {limit}.",
  "Automation rules": "Otomasyon kuralları",
  "Custom metrics": "Özel metrikler",
  "Conversion types": "Dönüşüm türleri",
  "API keys": "API anahtarları",
  "Webhooks": "Webhook’lar",
  "Cost sync": "Maliyet senkronizasyonu",
  "Domain pools": "Alan adı havuzları",
  "Lead forms": "Lead formları",
  "Users": "Kullanıcılar",
  "Domains": "Alan adları",
  "Scheduled reports": "Zamanlanmış raporlar",
  "Public report links": "Herkese açık rapor bağlantıları",
};

const uk = {
  "If you switch to {plan}:": "У разі переходу на {plan}:",
  "{feature}: {n} in use, not included in this plan.": "{feature}: використовується — {n}, у цьому тарифі немає.",
  "{feature}: {n} now, {limit} on this plan.": "{feature}: зараз {n}, у цьому тарифі — {limit}.",
  "Automation rules": "Правила автоматизації",
  "Custom metrics": "Власні метрики",
  "Conversion types": "Типи конверсій",
  "API keys": "API-ключі",
  "Webhooks": "Вебхуки",
  "Cost sync": "Синхронізація витрат",
  "Domain pools": "Пули доменів",
  "Lead forms": "Форми із заявками",
  "Users": "Користувачі",
  "Domains": "Домени",
  "Scheduled reports": "Звіти за розкладом",
  "Public report links": "Публічні посилання на звіти",
};

const DOWNGRADE_IMPACT = { ru, es, pt, de, fr, it, pl, tr, uk };
export default DOWNGRADE_IMPACT;
